import { ApiDatafanSootherAuth } from "../../soother_auth";
let smpAsDatafanToken = null;
let smpAsDatafanTokenPromise;
export const getSmpAsDatafanToken = () => smpAsDatafanToken;
const setSmpAsDatafanToken = (token) => {
    smpAsDatafanToken = token;
    return token;
};
export const refreshSmpAsDatafanToken = () => {
    if (!smpAsDatafanTokenPromise) {
        smpAsDatafanTokenPromise = ApiDatafanSootherAuth.get();
    }
    return smpAsDatafanTokenPromise
        .then((token) => setSmpAsDatafanToken(token || null))
        .finally(() => {
        smpAsDatafanTokenPromise = null;
    });
};
//# sourceMappingURL=smp_token.js.map